// extracted by mini-css-extract-plugin
module.exports = {"button":"Z6y+X+N+7YOkMmhAr-4htw=="};